import React from "react";

import { Tooltip } from "antd";
import moment from "moment";

import LockedValue from "../../../../grace-period/components/LockedValue";
import { useAccessStatus } from "../../../../grace-period/hooks/useAccessStatus";

const EnvAnalyticsTableRow = ({ row, headers }) => {
  const { areResultsLocked } = useAccessStatus();
  const inSpec = row.in_spec_num;
  const outOfSpec = row.out_of_spec_num;
  const noSpec = row.no_spec_num;
  const total = row.total;
  const hasNoData = total === 0 || (inSpec === 0 && outOfSpec === 0 && noSpec === 0);
  const redPercent = total > 0 ? (outOfSpec / total) * 100 : 0;
  const yellowPercent = total > 0 ? (noSpec / total) * 100 : 0;
  const greenPercent = Math.max(0, 100 - redPercent - yellowPercent);

  return (
    <tr className="EnvAnalyticsTableRow__TableRow">
      {headers.map((header, index) => {
        let cellContent;

        if (header === "Status") {
          cellContent = areResultsLocked ? (
            <LockedValue locked variant="bar" />
          ) : (
            <Tooltip
              title={(
                <div className="EnvAnalyticsTableRow__CustomTooltip">
                  <p className="EnvAnalyticsTableRow__TooltipTotal">
                    {`Total Sample: ${total}`}
                  </p>
                  <p className="EnvAnalyticsTableRow__TooltipOutOfSpec">
                    {`Out of Spec: ${outOfSpec}`}
                  </p>
                  <p className="EnvAnalyticsTableRow__TooltipInSpec">
                    {`In Spec: ${inSpec}`}
                  </p>
                  <p className="EnvAnalyticsTableRow__TooltipIncompleteSpec">
                    {`Incomplete Spec: ${noSpec}`}
                  </p>
                </div>
              )}
              placement="topLeft"
              classNames={{ root: "EnvAnalyticsTableRow__CustomTooltipOverlay" }}
            >
              <div className="EnvAnalyticsTableRow__ProgressBar">
                {hasNoData ? (
                  <div
                    className="EnvAnalyticsTableRow__ProgressBarEmpty"
                    style={{ width: "100%" }}
                  />
                ) : (
                  <>
                    <div
                      className="EnvAnalyticsTableRow__ProgressBarRed"
                      style={{ flex: `0 0 ${redPercent}%` }}
                    />
                    <div
                      className="EnvAnalyticsTableRow__ProgressBarYellow"
                      style={{ flex: `0 0 ${yellowPercent}%` }}
                    />
                    <div
                      className="EnvAnalyticsTableRow__ProgressBarGreen"
                      style={{ flex: `0 0 ${greenPercent}%` }}
                    />
                  </>
                )}
              </div>
            </Tooltip>
          );
        } else if (header === "Out of Spec Samples") {
          cellContent = areResultsLocked ? (
            <LockedValue locked />
          ) : (
            <span
              className={`EnvAnalyticsTableRow__Row ${
                row.out_of_spec_num === 0 && row.in_spec_num === 0
                  ? "EnvAnalyticsTableRow__Row--NoRatio"
                  : ""
              }`}
            >
              {row.out_of_spec_num === 0 && row.in_spec_num === 0
                ? "-"
                : `${((row.out_of_spec_num / total) * 100).toFixed(0)}%`}
            </span>
          );
        } else if (header === "Swab ID") {
          cellContent = (
            <div className="EnvAnalyticsTableRow__SwabID">
              {row.swab}
            </div>
          );
        } else if (header === "Last submitted on") {
          cellContent = (
            <span className="EnvAnalyticsTableRow__TextRow">
              {moment(row.last_submitted).format("MMM DD YYYY")}
            </span>
          );
        } else if (header === "No of days since last submission") {
          cellContent = (
            <span className="EnvAnalyticsTableRow__TextRow">
              {row.day_till_now}
              {" "}
              Days
            </span>
          );
        } else {
          cellContent = row[header];
        }

        return (
          <td
            key={index}
            className={
              header !== "Swab ID"
                ? "EnvAnalyticsTableRow__TableData"
                : ""
            }
          >
            {cellContent}
          </td>
        );
      })}
    </tr>
  );
};

export default EnvAnalyticsTableRow;
